import React from "react";

import {Text} from "@pg-design/text";
import {rpAppLink} from "@pg-mono/rp-routes";
import {pluralize} from "@pg-mono/string-utils";

import {offerUrlBuilder} from "../../offer/helpers/friendly_offer_list/offer_url_builder";
import {getCountryName} from "../../offer/list/helpers/sub_type/get_fetch_offer_list_subfilter_query";
import {Country} from "../../region/types/Country";
import {fetchSingleRegionSimple} from "../actions/fetch_search_regions_action";
import {SearchTab} from "../types/SearchTab";
import {SearchInfoWindowCitiesList, SearchInfoWindowCitiesListSpain} from "../utils/search_info_window_cities_list";
import {resultsList} from "./atoms/atoms";
import {ResultsListItem} from "./atoms/ResultsListItem";
import {ISearchInputValue} from "./ISearchInputValue";
import {RecentFiltersSearch} from "./RecentFiltersSearch";

interface IProps {
    activeItemId: number | null;
    onLinkClick: (option: ISearchInputValue) => void;
    country?: Country;
    hideRecentFilters?: boolean;
}

export const SuggestedRegions = (props: IProps) => {
    const onSuggestedRegionLinkClick = async (item: {id: number}) => {
        const suggestedRegion = await fetchSingleRegionSimple(item.id);
        props.onLinkClick({
            label: suggestedRegion.full_name_reverted,
            tabType: SearchTab.Regions,
            regions: [suggestedRegion]
        });
    };
    const allSpainResultsHandler = () => {
        const {friendlySlug} = offerUrlBuilder({region: ""});
        window.location.href = rpAppLink.offer.listFriendlyAbroad({
            friendlySlug: friendlySlug,
            country: getCountryName(Country.SPAIN)
        });
    };

    const SuggestedRegionList = props.country === Country.SPAIN ? SearchInfoWindowCitiesListSpain : SearchInfoWindowCitiesList;

    return (
        <>
            {/* Recent filters search is only shown in Poland and when not explicitly hidden (e.g. property configurator) */}
            {props.country === Country.POLAND && !props.hideRecentFilters && <RecentFiltersSearch />}

            <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                Najczęściej wybierane
            </Text>

            <ul css={resultsList}>
                {props.country === Country.SPAIN && <ResultsListItem title="Wszystkie lokalizacje w Hiszpanii" onClick={allSpainResultsHandler} />}
                {SuggestedRegionList.map((item, idx) => {
                    const propertiesCount = item.offerCount;
                    const propertiesFormat = pluralize(["oferta", "oferty", "ofert"])(propertiesCount);

                    return (
                        <ResultsListItem
                            key={idx}
                            idx={idx}
                            activeItemId={props.activeItemId}
                            onClick={() => onSuggestedRegionLinkClick(item)}
                            title={item.label}
                            subTitle={item.regionFull}
                            countLabel={`${propertiesCount} ${propertiesFormat}`}
                        />
                    );
                })}
            </ul>
        </>
    );
};
